// extracted by mini-css-extract-plugin
export default {"body":"section_body__mHNUo","strong":"section_strong__M1cMV"};